//@ts-ignore
import { Box, Button, Grid, Stack, Typography } from '@mui/material';

// ==============================|| OFFLINE PAGE ||============================== //

function OfflinePage() {
  const handleRefresh = () => {
    window.location.reload();
  };
  return (
    <Grid container spacing={3} direction="column" alignItems="center" justifyContent="center" sx={{ minHeight: '100vh', py: 2 }}>
      <Grid item xs={12}>
        <Box sx={{ width: { xs: 300, sm: 374 } }}>
          <img src={'offline.png'} alt="offline" style={{ width: '100%', height: 'auto' }} />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Stack spacing={2} justifyContent="center" alignItems="center">
          <Typography align="center" variant="h1">
            You are offline
          </Typography>
          <Typography color="textSecondary" align="center" sx={{ width: '85%' }}>
            Oops! It looks like you're offline. Please check your internet connection and try again.
          </Typography>
          <Button variant="contained" onClick={handleRefresh}>
            Refresh
          </Button>
        </Stack>
      </Grid>
    </Grid>
  );
}

export default OfflinePage;
